import Param from './param';
import effectManager from './module/effect';
import topManager from './page/top';
import worksManager from './page/works';
import getInstagram from './module/libs/instagram';
import notFoundManager from './page/notFound';
import lowlayerManager from './page/lowlayer';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import globalNavi from './module/global/globalNavi';
import webglManager from './module/webgl/manager';
import GoogleMapManager from './module/libs/googlemap';
import ModalManager from './module/modal/modalManager';


const param = new Param();
let effect;
let scroll;
let mouse;
let gNavi;
let toppage;
let workspage;
let lowlayer;
let googleMap;
let notFound;
let getInsta;
const webgl = new webglManager();


const stats = new Stats();
stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild( stats.dom );

let pageID = $("body").attr("id");
let executionType = "landing"; /* 実行タイミングの制御用 */

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {
    if(!requestAnimationFrame){
        setTimeout(function () {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }


    stats.begin();

    scroll.move();
    mouse.move();
    webgl.render(mouse.obj);


    if(!scroll.webglStop&&pageID==="top") {
        toppage.render(mouse.obj);
    }

    if(pageID!=="top"&&lowlayer) lowlayer.render(scroll.inc);

    stats.end();

}

/* ---------------------------------------------------

  --

 --------------------------------------------------- */


let common = function () {

    effect = new effectManager();
    scroll = new smoothScrollManager();
    mouse = new MouseManager();
    gNavi = new globalNavi();

    gNavi.init();

    if(pageID!=="top"){
        lowlayer = new lowlayerManager();
    }else{
        toppage = new topManager();
    }


    // if(type!=="landing"){
    // }

    $('html,body').animate({ scrollTop: 0 }, 0);
    effect.show($(".js__splash-show"),"set");
    effect.splitText($(".js__splash-splittext"),"set");
    TweenMax.set($("#l-header"),{y:-100,opacity:1});
    TweenMax.set($("#c-scrolldown"),{x:100});


    // console.log(webgl);

    if(executionType==="landing") webgl.init();

    setTimeout(function(){
        resize();
        scroll.init();
    },1e2);
    setTimeout(function(){
        /* loader */
        // TweenMax.to($(".pace"),0.9,{y:-window.innerHeight,ease:Back.easeIn.config(1.7)});
        TweenMax.staggerTo($("#l-loader >*"),0.7,{
            y : - window.innerHeight * 1.1,
            ease: Power2.easeIn,
            onComplete:function () {
                setTimeout(function () {
                    TweenMax.set($("#l-loader"),{display:"none"});
                },3e2);
            }
        },0.05);
        setTimeout(function(){
            if(executionType==="landing") render();
        },3e2);
    },6e2);


        /* lowlayer */
        if(pageID!=="top"){
            TweenMax.to($("#c-page-header"),0.8,{
                width:100+"%",ease:Power2.easeOut,
                onComplete:function () {
                    $("#c-page-header").addClass("is-done");
                    if($(".js__splash-show")[0]) effect.show($(".js__splash-show"),"show");
                    if($(".js__splash-splittext")[0]) effect.splitText($(".js__splash-splittext >* >*"),"show");
                }
            });
        }else{
            setTimeout(function(){
                if($(".js__splash-show")[0]) effect.show($(".js__splash-show"),"show");
            },2e3);
        }


        TweenMax.to($("#l-header"),0.9,{y:0,ease:Power2.easeOut});
        TweenMax.to($("#c-scrolldown"),0.9,{x:0,ease:Power2.easeOut});



    pageManager(pageID);



}

let pageManager = function(){

    switch(pageID){
        case "top":
            toppage.init();
            break;
        case "works":
            /* インスタは予め読み込んでおく */
            getInsta= new getInstagram;
            getInsta.init();
            setTimeout(function () {
            },1e3);
            setTimeout(function () {
                executionType = "pjax";
                // getInsta.$container.html(getInsta.dom.replace( /undefined/g,'' ));
               resize();
            },3e3);
            setTimeout(function () {
                executionType = "pjax";
                resize();
            },6e3);
            break;
        case "company":
            googleMap = new GoogleMapManager();
            googleMap.init();
        case "notFound":
            notFound = new notFoundManager();
            notFound.init();
            break;
    }

}

let _preW = 0; /*前回の横幅を保持*/

let resize = function () {



    param.displayType = ( window.innerWidth>param.breakpoint )?"pc":"sp";


    scroll.resize(param.displayType);
    gNavi.resize();

    if(pageID==="top"){


        // if(Useragnt.mobile||Useragnt.tablet){
        //     if(_preW===window.innerWidth&&executionType==="resize"){
        //         _preW = window.innerWidth;
        //         return;
        //     }else{
        //         // toppage.resize();
        //     }
        // }else{
            toppage.resize();
        // }

    }else{
       lowlayer.resize();
    }

    webgl.resize();

}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

// effect.svgInit();

$(window).on("load", function (e) {
// Pace.on("done", function () {
    executionType = "landing";
    TweenMax.set($("#l-root"),{opacity:1});
    common();
    $('html,body').animate({ scrollTop: 0 }, '1');

});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

$('a:not([href^="mailto:"])').on("click",function () {
    $(this).addClass("is-none"); /* 非同期遷移用にダブルクリックの対策 */
})

/* pagetop */
$('.c-pagetop').on("click",function () {
    scroll.update(0,"prev");
    $('html,body').animate({ scrollTop: 0 }, '200');
});
/* globalnavi */
/* lowlayer scroll */
$(window).on("scroll", function (e) {

    scroll.inertia = (Useragnt.mobile||Useragnt.tablet)?false:true;

    let _y = window.pageYOffset || document.documentElement.scrollTop;
    scroll.update(_y,"");
});
window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;


    mouse.update(_x,_y);

});

if(Useragnt.pc){
}else{
    // window.addEventListener("deviceorientation",function (e) {
    //
    //
    //     const _degtorad = Math.PI / 180;
    //
    //     const _x = e.beta ? e.beta * _degtorad : 0;
    //     const _y = e.gamma ? e.gamma * _degtorad : 0;
    //     const _z = e.alpha ? e.alpha * _degtorad : 0;
    //
    //     const _sX = Math.sin(_x);
    //     const _sY = Math.sin(_y);
    //
    //
    //     // mouse.update(_sX,_sY);
    //
    // });
}

$(window).on("resize",function (e) {
    executionType = "resize";
    resize();

});
$(window).on("onorientationchange",function (e) {
    executionType = "onorientationchange";
    resize();

});


/* ---------------------------------------------------

  -- PJAX

 --------------------------------------------------- */

Barba.Pjax.start();
Barba.Prefetch.init();

var PageTransition = Barba.BaseTransition.extend({
    start: function() {

        /* 画面遷移する際に発火 */

        Promise
            .all([this.newContainerLoading, this.out()])
            .then(this.show.bind(this));
    },

    out: function() {

        /* 画面遷移時に消える処理 */

        effect.splitText($(this.oldContainer).find(".js__tsc-splittext"),"out");
        effect.show($(this.oldContainer).find(".js__tsc-show,.js__splash-show"),"out");
        effect.scale($(this.oldContainer).find(".js__tsc-scale"),"out");


        let _this = this;


        webgl.timer = 0;
        webgl.conf.splash.flg = false;
        webgl.conf.splash.time = 60;
        webgl.conf.ball.mode = "splash";
        webgl.conf.ball.NUM = param.webgl.ball.num.splash;


        TweenMax.to($("#l-root"),0.6, {
            opacity: 0,
            ease: Power2.easeIn,
            onComplete:function () {
                TweenMax.set($(_this.oldContainer),{visibility : 'visible',opacity : 0});
            }
        });

        // return $(this.oldContainer).animate({ opacity: 0 }).promise();
    },

    show: function() {

        /* 画面遷移時に表示される処理 */

        var _this = this;
        var $el = $(this.newContainer);


        TweenMax.set($el,{visibility : 'visible',opacity : 0});

        setTimeout(function () {


            $(this.oldContainer).hide();
            $("body").attr("id",pageID);
            TweenMax.to($("#l-root"),0.6,{
                opacity : 1,
                ease: Power2.easeIn,
                onStart:function () {
                },
                onComplete:function () {
                    _this.done();
                    common("transition");
                    TweenMax.set($el,{opacity : 1});
                    $('html,body').animate({ scrollTop: 0 }, '1');
                }
            });

        },1e3);

    }
});



Barba.Dispatcher.on('linkClicked', function() {
    //console.log("開始");

});
Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {


    /* ページ情報取得 */
    pageID = currentStatus.namespace;

    /* head内書き換え */
    var head = document.head;
    var newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    var newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    var removeHeadTags = [
        "meta[name='keywords']"
        ,"meta[name='description']"
        ,"meta[property^='og']"
        ,"meta[name^='twitter']"
        ,"meta[itemprop]"
        ,"link[itemprop]"
        ,"link[rel='prev']"
        ,"link[rel='next']"
        ,"link[rel='canonical']"
    ].join(',');
    var headTags = head.querySelectorAll(removeHeadTags)
    for(var i = 0; i < headTags.length; i++ ){
        head.removeChild(headTags[i]);
    }
    var newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for(var i = 0; i < newHeadTags.length; i++ ){
        head.appendChild(newHeadTags[i]);
    }

    executionType = "pjax";

    //アナリティクスに送信
    // ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search);

    /* html書き換え */

});

Barba.Pjax.getTransition = function() {
    // console.log("getTransition");
    return PageTransition;
};
Barba.Dispatcher.on("load", function() {
    // console.log("test");
});

Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
Barba.Pjax.preventCheck = function(evt, element) { //ハッシュが含まれていてもbarbaが機能するように
    if ($(element).attr('href') && $(element).attr('href').indexOf('#') > -1)
        return true;
    else
        return Barba.Pjax.originalPreventCheck(evt, element)
};

